import {
    widgetsByIdSelector
} from '../../dashboard/selectors/widget-selectors';
import {
    fetchAggResultsByCanvasId
} from '../../common/actions/aggregate-results-action-creators';
import {
    allDomainsInAggDataSelector
} from '../../common/selectors/aggregate-results-selectors';
import {
    fetchActions
} from '../../common/actions/actions-action-creators';

export function initializeMyDomainsWidget( widgetId ){
    return ( dispatch, getState ) => {
        const canvasId = widgetsByIdSelector( getState() )[widgetId].canvasId;

        return dispatch( fetchAggResultsByCanvasId( canvasId ) )
            .then( () => {
                const domains = allDomainsInAggDataSelector( getState() );
                return dispatch( fetchActions( domains ) );
            } );

    };
}
